import Vue from 'vue'
import {
  MdButton,
  MdContent,
  MdField,
  MdList,
  MdMenu,
  MdProgress,
  MdRadio,
  MdRipple,
  MdTable,
  MdToolbar
} from 'vue-material/dist/components'
import ToastPlugin from 'vue-toast-notification'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'vue-toast-notification/dist/theme-bootstrap.css'

import router from './router'
import store from './store'
import i18n from './i18n'

import App from './App.vue'

Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdField)
Vue.use(MdList)
Vue.use(MdMenu)
Vue.use(MdProgress)
Vue.use(MdRadio)
Vue.use(MdRipple)
Vue.use(MdTable)
Vue.use(MdToolbar)
Vue.use(ToastPlugin)

new Vue({
  i18n,
  render: h => h(App),
  router,
  store
}).$mount('#app')
